/**
 * Given a NODE_EVN returns either development or production API object. The production
 * object is returned by default.
 * @param  {string} env Current NODE_ENV
 * @return {string}     Either development or production url
 */
const getApi = (env) => {
  if (env === 'development') {
    return '//alypaafi-app.test/api/';
  }
  return 'https://app.alypaa.fi/api/';
  //  return 'https://app-cdn.alypaa.fi/api/';
};

export default getApi;
